// extracted by mini-css-extract-plugin
export default {"container":"vpadd_container__WH7X-","ddTrigger":"vpadd_ddTrigger__39pbX","ddContent":"vpadd_ddContent__1Bhcb","active":"vpadd_active__BBE6d","cardDeck":"vpadd_cardDeck__hox2x"};